import { createFileRoute } from "@tanstack/react-router";
import ResponsibleLending from "@/pages/legal/ResponsibleLending";

export const Route = createFileRoute("/responsible-lending")({
  component: ResponsibleLending,
});
